import { render, staticRenderFns } from "./AdjustmentsFormBulkPublishers.vue?vue&type=template&id=2a9f6564&scoped=true"
import script from "./AdjustmentsFormBulkPublishers.vue?vue&type=script&lang=js"
export * from "./AdjustmentsFormBulkPublishers.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentsFormBulkPublishers.vue?vue&type=style&index=0&id=2a9f6564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9f6564",
  null
  
)

export default component.exports